/* ============
 * Mutations for the account module
 * ============
 *
 * The mutations that are available on the
 * account module.
 */

import { FIND } from './mutation-types';

export default {
    [FIND](state, dharmam) {
        state.id = dharmam.id;
        state.name = dharmam.name;
        state.title = dharmam.title;
        state.text = dharmam.text;
        state.apiKey = dharmam.apiKey;
        state.apiSecret = dharmam.apiSecret;
    },
};


// WEBPACK FOOTER //
// ./src/store/modules/dharmams/mutations.js